"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultComponent = function defaultComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, props.children);
};

var _default = function _default(config) {
  if (config === void 0) {
    config = {};
  }

  var componentType = config.type;
  var Component = config.component || defaultComponent;

  if (config.decorator) {
    Component = config.decorator(Component);
  }

  var editorTheme = config.editorTheme;
  return {
    blockRendererFn: function blockRendererFn(block, _ref) {
      var getEditorState = _ref.getEditorState;

      if (block.getType() === 'atomic') {
        var contentState = getEditorState().getCurrentContent();
        var entity = block.getEntityAt(0);
        if (!entity) return null;
        var type = contentState.getEntity(entity).getType();

        if (type === componentType) {
          return {
            component: Component,
            editable: false,
            props: {
              editorTheme: editorTheme
            }
          };
        }

        return null;
      }

      return null;
    }
  };
};

exports["default"] = _default;
module.exports = exports.default;